/* assets/pc-slider.js  –  runs once, then re-runs whenever a section loads */
(function () {

  /* call this when the initial page finishes parsing */
  document.addEventListener('DOMContentLoaded', hydrateSliders);

  /* call again when Turbo loads new HTML via Ajax (Theme Editor, Load-More, etc.) */
  document.addEventListener('shopify:section:load', hydrateSliders);
  document.addEventListener('shopify:section:reorder', hydrateSliders);

  function hydrateSliders () {
    /** grab every .pc-slider that has *not* been initialised yet */
    document.querySelectorAll('.pc-slider:not([data-ready])')
      .forEach(initSlider);
  }

  function initSlider (slider) {
    slider.setAttribute('data-ready', 'true');          // flag as wired-up

    const img    = slider.querySelector('.pc-slide');
    const images = JSON.parse(slider.dataset.images)
                         .filter(m => m.media_type === 'image');
    let index    = 0;

    /* wire the buttons (if they exist) */
    slider.querySelector('.pc-arrow--prev')?.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      swap(-1);
    });
    slider.querySelector('.pc-arrow--next')?.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      swap(+1);
    });

    function swap (step) {
      if (!images.length) return;
      index = (index + step + images.length) % images.length;

      /* replicate Liquid’s _600x suffix for retina helper */
      const newSrc = images[index].src.replace(/(\.[a-z]+)$/, '_600x$1');
      img.setAttribute('data-src', newSrc);
      img.classList.remove('lazyloaded');   // re-trigger Lazysizes
      img.alt = images[index].alt || '';
    }
  }
})();
